import { useMemo } from "react";
import { PlanningFreightProbill } from "app/data/linehaul-outbound-planning/models";
import { usePlanningFreightList } from "./usePlanningFreightList";
import { usePlanningPickupList } from "./usePlanningPickupList";

export function useCombinedPlanningFreightList(
  originTerminalNumber: number | undefined,
  destinationTerminalNumbers: number[] | undefined,
  fetchId: string | undefined,
  enabled: boolean
) {
  const inHouse = usePlanningFreightList(
    "inHouse",
    originTerminalNumber,
    destinationTerminalNumbers,
    fetchId,
    enabled
  );
  const inbound = usePlanningFreightList(
    "inbound",
    originTerminalNumber,
    destinationTerminalNumbers,
    fetchId,
    enabled
  );
  const pickups = usePlanningPickupList(
    "pickupsAggregate",
    originTerminalNumber,
    destinationTerminalNumbers,
    fetchId,
    enabled
  );

  const data = useMemo(() => {
    const combined: PlanningFreightProbill[] = [
      ...(inHouse.data ?? []).map((row) => ({ ...row, freightType: "inHouse" as const })),
      ...(inbound.data ?? []).map((row) => ({ ...row, freightType: "inbound" as const })),
      ...(pickups.data ?? []).map((row) => ({ ...row, freightType: "pickup" as const })),
    ];
    return combined;
  }, [inHouse.data, inbound.data, pickups.data]);

  const isLoading =
    inHouse.isLoading || inbound.isLoading || pickups.isLoading;

  return {
    data,
    isLoading,
    isError: inHouse.isError || inbound.isError || pickups.isError,
    refetch: () => {
      inHouse.refetch();
      inbound.refetch();
      pickups.refetch();
    },
  };
}
